// extracted by mini-css-extract-plugin
module.exports = {"container":"Card-module__container--20-AE","header":"Card-module__header--oQFIj","headerIcon":"Card-module__headerIcon--K1bJS"};